angular
  .module('resources.User', ['ngResource'])
  .factory('User', ['$resource', function ($resource) {
    var User = $resource('/api', {id: '@_id'}, {
      query: {
        method: 'GET',
        isArray: false
      },
      update: {
        method: 'PUT'
      },
      completeSignup: {
        method: 'PUT',
        url: '/api/completeSignup'
      },
      updateAccount: {
        method: 'PUT',
        url: '/api/updateAccount'
      },
      changePassword: {
        method: 'PUT',
        url: '/api/password'
      },
      changeLogin: {
        method: 'PUT',
        url: '/api/credentials'
      },
      current: {
        method: 'GET',
        url: '/api/current-user',
        isArray: false,
      }
    });

    return User;
  }]);



// WEBPACK FOOTER //
// ./client/src/common/resources/User.js